import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const getOrganizations = (pageUrl) => {
  const orgUrl = pageUrl ? pageUrl : getUrl("orgs");
  return trackPromise(Call.get(orgUrl));
};

export const getOrganizationAsync = ({id}) => {
  const orgUrl = getUrl("org")(id);
  return trackPromise(Call.get(orgUrl));
};

export const createOrganization = (payload) => {
  const orgUrl = getUrl("orgs");
  return trackPromise(Call.post(orgUrl, payload));
};

export const syncTemplateAsync = (payload) => {
  const syncTemplate = getUrl("syncTemplate");
  return trackPromise(Call.post(syncTemplate, payload));
};

export const getOrganizationAppsAsync = ({id}) => {
  const orgUrl = getUrl("appsOrg")(id);
  return trackPromise(Call.get(orgUrl));
};
